import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarPortariaApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/concierge/createConcierge`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarPortariaApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/concierge/getDoormen`, body, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarPortariaApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/concierge/getConcierge`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarPortariaApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/concierge/updateconcierge`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirPortariaApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/concierge/deleteConcierge`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}